import { apiProxy } from '@/libs/api/apiProxy'
import {
  GetSummaryPermissionResponse,
  PostBooKPercentResponse,
  GetSummaryDetailResponse,
} from '@/types/summary'

export const postSummaryPercent = (
  summaryId: number,
  percent: number
): Promise<PostBooKPercentResponse> => {
  return apiProxy.post<PostBooKPercentResponse>(
    `/api/summary/percent/${summaryId}`,
    { percent }
  )
}

export const getSummaryPermission = (
  summaryId: number
): Promise<GetSummaryPermissionResponse> => {
  return apiProxy.get<GetSummaryPermissionResponse>(
    `/api/summary/permission/${summaryId}`
  )
}

export const getSummaryDetail = (
  summaryId: number,
  code: string
): Promise<GetSummaryDetailResponse> => {
  return apiProxy.get<GetSummaryDetailResponse>(
    code
      ? `/api/summary/detail/${summaryId}?code=${code}`
      : `/api/summary/detail/${summaryId}`
  )
}
